import { useState } from 'react';

export interface BulkProgress {
  queued: number;
  total: number;
}

const BATCH_SIZE = 50;
const BATCH_DELAY = 800;

export function useBulkAction() {
  const [progress, setProgress] = useState<BulkProgress | null>(null);

  const execute = async (
    ids: number[],
    action: (batchIds: number[]) => Promise<void>,
  ): Promise<number> => {
    const batches: number[][] = [];
    for (let i = 0; i < ids.length; i += BATCH_SIZE) {
      batches.push(ids.slice(i, i + BATCH_SIZE));
    }

    setProgress({ queued: 0, total: ids.length });
    const promises: Promise<void>[] = [];

    for (let i = 0; i < batches.length; i++) {
      promises.push(action(batches[i]));
      setProgress({
        queued: Math.min((i + 1) * BATCH_SIZE, ids.length),
        total: ids.length,
      });
      if (i < batches.length - 1) {
        await new Promise<void>((resolve) => setTimeout(resolve, BATCH_DELAY));
      }
    }

    const results = await Promise.allSettled(promises);
    setProgress(null);
    return results.filter((r) => r.status === 'rejected').length;
  };

  return { progress, execute };
}
